<div
  @transformPopover
  class="vex-popover">
  @switch (renderMethod) {
    @case ("text") {
      <div [innerHTML]="content"></div>
    }
    @case ("template") {
      <ng-container *ngTemplateOutlet="content; context: context" />
    }
    @case ("component") {
      <ng-container *ngComponentOutlet="content" />
    }
  }
</div>
